// AUTO-GENERATED by sync-icons — do not edit.
import AquariumIconSvg from './AquariumIcon';
import BoilerIconSvg from './BoilerIcon';
import BoilerServiceIconSvg from './BoilerServiceIcon';
import ElectricityIconSvg from './ElectricityIcon';
import GasIconSvg from './GasIcon';
import HappyPowerIconSvg from './HappyPowerIcon';
import HappyPowerLoyaltyIconSvg from './HappyPowerLoyaltyIcon';
import HappyPowerLoyaltyInvertedIconSvg from './HappyPowerLoyaltyInvertedIcon';
import HeatingLevelFullIconSvg from './HeatingLevelFullIcon';
import HeatingLevelLowIconSvg from './HeatingLevelLowIcon';
import HeatingLevelMediumIconSvg from './HeatingLevelMediumIcon';
import HeatingLevelOffIconSvg from './HeatingLevelOffIcon';
import HeatPumpIconSvg from './HeatPumpIcon';
import HomeBatteryIconSvg from './HomeBatteryIcon';
import HomeInsulationIconSvg from './HomeInsulationIcon';
import PowerGridIconSvg from './PowerGridIcon';
import QuookerIconSvg from './QuookerIcon';
import RedeliveryIconSvg from './RedeliveryIcon';
import RentalDeviceIconSvg from './RentalDeviceIcon';
import SolarPanelIconSvg from './SolarPanelIcon';
import SourceHeatIconSvg from './SourceHeatIcon';
import StandbyUseIconSvg from './StandbyUseIcon';
import SunIconSvg from './SunIcon';
import ToonIconSvg from './ToonIcon';
import ToonServiceIconSvg from './ToonServiceIcon';
import WarmthIconSvg from './WarmthIcon';
import WaterColdIconSvg from './WaterColdIcon';
import WaterWarmIconSvg from './WaterWarmIcon';
import { withIconWrapper } from '../../IconWrapper';
export const AquariumIcon = withIconWrapper(AquariumIconSvg);
export const BoilerIcon = withIconWrapper(BoilerIconSvg);
export const BoilerServiceIcon = withIconWrapper(BoilerServiceIconSvg);
export const ElectricityIcon = withIconWrapper(ElectricityIconSvg);
export const GasIcon = withIconWrapper(GasIconSvg);
export const HappyPowerIcon = withIconWrapper(HappyPowerIconSvg);
export const HappyPowerLoyaltyIcon = withIconWrapper(HappyPowerLoyaltyIconSvg);
export const HappyPowerLoyaltyInvertedIcon = withIconWrapper(HappyPowerLoyaltyInvertedIconSvg);
export const HeatingLevelFullIcon = withIconWrapper(HeatingLevelFullIconSvg);
export const HeatingLevelLowIcon = withIconWrapper(HeatingLevelLowIconSvg);
export const HeatingLevelMediumIcon = withIconWrapper(HeatingLevelMediumIconSvg);
export const HeatingLevelOffIcon = withIconWrapper(HeatingLevelOffIconSvg);
export const HeatPumpIcon = withIconWrapper(HeatPumpIconSvg);
export const HomeBatteryIcon = withIconWrapper(HomeBatteryIconSvg);
export const HomeInsulationIcon = withIconWrapper(HomeInsulationIconSvg);
export const PowerGridIcon = withIconWrapper(PowerGridIconSvg);
export const QuookerIcon = withIconWrapper(QuookerIconSvg);
export const RedeliveryIcon = withIconWrapper(RedeliveryIconSvg);
export const RentalDeviceIcon = withIconWrapper(RentalDeviceIconSvg);
export const SolarPanelIcon = withIconWrapper(SolarPanelIconSvg);
export const SourceHeatIcon = withIconWrapper(SourceHeatIconSvg);
export const StandbyUseIcon = withIconWrapper(StandbyUseIconSvg);
export const SunIcon = withIconWrapper(SunIconSvg);
export const ToonIcon = withIconWrapper(ToonIconSvg);
export const ToonServiceIcon = withIconWrapper(ToonServiceIconSvg);
export const WarmthIcon = withIconWrapper(WarmthIconSvg);
export const WaterColdIcon = withIconWrapper(WaterColdIconSvg);
export const WaterWarmIcon = withIconWrapper(WaterWarmIconSvg);
